import React, { useState, useMemo } from "react";
import { observer } from "mobx-react";
import "./index.css";
import GlobalState from "../../../stores/GlobalState";
import lang from "../../../lang";

const STEP = 0.05;

function roundToStep(value, step = STEP) {
  return Math.round(value / step) * step;
}
function sameStep(a, b, step = STEP) {
  return Math.abs(roundToStep(a, step) - roundToStep(b, step)) < 1e-9;
}

const Accuracy = observer(({ lower, upper }) => {
  const [langmenu] = useState(localStorage.getItem("lang_site") || "en");
  const [langv] = useState(langmenu == "de" ? lang.de : lang.en);

  const meta = GlobalState.activemodel?.lastTrain?.metadata;
  const oldMetrics = meta?.metrics; // ЗВІДСИ БЕРЕМО ТІЛЬКИ AUC (+ old counters якщо треба)

  const doubleThresholdsData = meta?.doubleThresholdsData || [];

  const selectedDouble = useMemo(() => {
    if (!Array.isArray(doubleThresholdsData) || !doubleThresholdsData.length) return null;

    const l = roundToStep(Number(lower ?? 0));
    const u = roundToStep(Number(upper ?? 0));

    return (
      doubleThresholdsData.find(
        (o) => sameStep(o.lowerThreshold, l) && sameStep(o.upperThreshold, u)
      ) || null
    );
  }, [doubleThresholdsData, lower, upper]);

  // Робимо "metrics" у старому форматі, але з даних трешхолда
  const metricsLike = useMemo(() => {
    if (!selectedDouble) {
      // якщо ще нема selectedDouble (перший рендер) — fallback на старі metrics
      return oldMetrics || {};
    }

    return {
      accuracy: selectedDouble.accuracy,
      targets: [
        {
          target: 0,
          recall: selectedDouble.recall0,
          precision: selectedDouble.precision0,
          f1Score: selectedDouble.f1Score0,
        },
        {
          target: 1,
          recall: selectedDouble.recall1,
          precision: selectedDouble.precision1,
          f1Score: selectedDouble.f1Score1,
        },
      ],

      // ВАЖЛИВО: auc НЕМА в doubleThresholdsData, беремо зі старих metrics
      auc: oldMetrics?.auc,
      confusionMatrix: selectedDouble.confusionMatrix,
      // ці лічильники в doubleThresholdsData нема (звичайно), тому лишаємо як було
      correctPredictions: oldMetrics?.correctPredictions,
      predictionsTotal: oldMetrics?.predictionsTotal,
    };
  }, [selectedDouble, oldMetrics]);

  const acc = typeof metricsLike?.accuracy === "number" ? metricsLike.accuracy : 0;

  const auc = metricsLike?.auc;
  const confusionMatrix = metricsLike?.confusionMatrix;
  const aucPercent = typeof auc === "number" && isFinite(auc) ? (auc * 100).toFixed(1) : "n/a";
  console.log(selectedDouble)
  return (
    <div className="accuracy_block">

      <div 
        className="accuracy_left" 
        style={
          GlobalState.activemodel?.lastTrain?.learningType == "binary"
            ? {}
            : { maxWidth: 'calc(21% - 70px)' }
        } 
      >
        <div className="accuraccy_1_one_blcok" bis_skin_checked="1">
          <div className="accuracy_left_title" bis_skin_checked="1">
            Observations
          </div>
          <div className="accuracy_left_value yelow" bis_skin_checked="1" style={{color:"#007AFF"}}>
            {(GlobalState.activemodel?.lastTrain?.metadata?.observationsTotal||null)/1000}К
          </div>
          <div className="accuracy_left_subtitle" bis_skin_checked="1">
            {(GlobalState.activemodel?.lastTrain?.metadata?.observationsPercent||null)*100}% of the {(GlobalState.activemodel?.lastTrain?.metadata?.testSegmentSize||null)*1} observations in the testing dataset
          </div>
        </div>
      </div>


      <div 
        className="accuracy_left" 
        style={
          GlobalState.activemodel?.lastTrain?.learningType == "binary"
            ? {}
            : { maxWidth: 'calc(21% - 70px)' }
        } 
      >
        <div className="accuraccy_1_one_blcok">
          <div className="accuracy_left_title">{langv?.module_models?.accuracy?.text1}</div>

          <div
            className="accuracy_left_value"
            style={
              acc >= 0 && acc <= 0.49
                ? { color: "rgba(234, 67, 52, 1)" }
                : acc > 0.49 && acc <= 0.59
                ? { color: "rgba(235, 115, 27, 1)" }
                : acc > 0.59 && acc <= 0.69
                ? { color: "rgba(66, 133, 244, 1)" }
                : acc > 0.69 && acc <= 0.79
                ? { color: "rgba(65, 168, 177, 1)" }
                : { color: "rgba(51, 167, 83, 1)" }
            }
          >
            {(acc * 100).toFixed(1)} %
          </div>

          <div className="accuracy_left_subtitle">

            {
              confusionMatrix?.[0]?.[0]!= null?
              (confusionMatrix?.[0]?.[0]+confusionMatrix[1][1]):
              "n/a"
            }
            {" "}
            {/* {metricsLike?.correctPredictions != null ? metricsLike.correctPredictions : "n/a"}{" "} */}
            
            
            <span dangerouslySetInnerHTML={{ __html: langv?.module_models?.accuracy?.text2 }} />
            {" "}
            {
              confusionMatrix?.[0]?.[0]!= null?
              (confusionMatrix?.[0]?.[0]+confusionMatrix[1][1]+confusionMatrix?.[0]?.[1]+confusionMatrix?.[1]?.[0]):
              "n/a"
            }
            {/* {metricsLike?.predictionsTotal || "n/a"}{" "} */}
           
           
            <span dangerouslySetInnerHTML={{ __html: langv?.module_models?.accuracy?.text3 }} />
          </div>
        </div>
      </div>

      {/* ROC AUC (тільки з metrics.auc) */}
      {

       GlobalState.activemodel?.lastTrain?.learningType == "binary" ?
        <div className="accuracy_left" bis_skin_checked="1">
          <div className="accuraccy_1_one_blcok" bis_skin_checked="1">
            <div className="accuracy_left_title" bis_skin_checked="1">
              ROC AUC
            </div>
            <div className="accuracy_left_value yelow" bis_skin_checked="1">
              {aucPercent} %
            </div>
            <div className="accuracy_left_subtitle" bis_skin_checked="1">
              The model can distinguish buyers from non-buyers with {aucPercent} % ranking quality
            </div>
          </div>
        </div>
        :
        <></>
      }

      <div className="accuracy_right">
        <div className="line_1_accur">
          <div className="accuracy_right_col">
            <label>{langv?.module_models?.accuracy?.text5}</label>
            {metricsLike?.targets?.map((n, id) =>
              GlobalState.activemodel?.lastTrain?.learningType == "binary" ? (
                <input
                  key={`t-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  value={n.target}
                />
              ) : id < metricsLike.targets.length-1 ? (
                <input
                  key={`t-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  value={n.target||'NULL'}
                />
              ) : (
                <></>
              )
            )}
          </div>

          <div className="accuracy_right_col">
            <label>{langv?.module_models?.accuracy?.text7}</label>
            {metricsLike?.targets?.map((n, id) =>
              GlobalState.activemodel?.lastTrain?.learningType == "binary" ? (
                <input
                  key={`r-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  style={
                    n.recall >= 0 && n.recall < 0.5
                      ? { color: "rgba(234, 67, 52, 1)" }
                      : n.recall >= 0.5 && n.recall < 0.6
                      ? { color: "rgba(235, 115, 27, 1)" }
                      : n.recall >= 0.6 && n.recall < 0.7
                      ? { color: "rgba(66, 133, 244, 1)" }
                      : n.recall >= 0.7 && n.recall < 0.8
                      ? { color: "rgba(65, 168, 177, 1)" }
                      : { color: "rgba(51, 167, 83, 1)" }
                  }
                  value={(n.recall ?? 0).toFixed(2)}
                />
              ) : id < metricsLike.targets.length-1 ? (
                <input
                  key={`r-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  style={
                    n.recall >= 0 && n.recall < 0.5
                      ? { color: "rgba(234, 67, 52, 1)" }
                      : n.recall >= 0.5 && n.recall < 0.6
                      ? { color: "rgba(235, 115, 27, 1)" }
                      : n.recall >= 0.6 && n.recall < 0.7
                      ? { color: "rgba(66, 133, 244, 1)" }
                      : n.recall >= 0.7 && n.recall < 0.8
                      ? { color: "rgba(65, 168, 177, 1)" }
                      : { color: "rgba(51, 167, 83, 1)" }
                  }
                  value={(n.recall ?? 0).toFixed(2)}
                />
              ) : (
                <></>
              )
            )}
          </div>

          <div className="accuracy_right_col">
            <label>{langv?.module_models?.accuracy?.text9}</label>
            {metricsLike?.targets?.map((n, id) =>
              GlobalState.activemodel?.lastTrain?.learningType == "binary" ? (
                <input
                  key={`p-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  style={
                    n.precision >= 0 && n.precision <= 0.49
                      ? { color: "rgba(234, 67, 52, 1)" }
                      : n.precision > 0.49 && n.precision <= 0.59
                      ? { color: "rgba(235, 115, 27, 1)" }
                      : n.precision > 0.59 && n.precision <= 0.69
                      ? { color: "rgba(66, 133, 244, 1)" }
                      : n.precision > 0.69 && n.precision <= 0.79
                      ? { color: "rgba(65, 168, 177, 1)" }
                      : { color: "rgba(51, 167, 83, 1)" }
                  }
                  value={(n.precision ?? 0).toFixed(2)}
                />
              ) : id < metricsLike.targets.length-1  ? (
                <input
                  key={`p-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  style={
                    n.precision >= 0 && n.precision <= 0.49
                      ? { color: "rgba(234, 67, 52, 1)" }
                      : n.precision > 0.49 && n.precision <= 0.59
                      ? { color: "rgba(235, 115, 27, 1)" }
                      : n.precision > 0.59 && n.precision <= 0.69
                      ? { color: "rgba(66, 133, 244, 1)" }
                      : n.precision > 0.69 && n.precision <= 0.79
                      ? { color: "rgba(65, 168, 177, 1)" }
                      : { color: "rgba(51, 167, 83, 1)" }
                  }
                  value={(n.precision ?? 0).toFixed(2)}
                />
              ) : (
                <></>
              )
            )}
          </div>

          <div className="accuracy_right_col">
            <label>{langv?.module_models?.accuracy?.text11}</label>
            {metricsLike?.targets?.map((n, id) =>
              GlobalState.activemodel?.lastTrain?.learningType == "binary" ? (
                <input
                  key={`f-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  style={
                    n.f1Score >= 0 && n.f1Score <= 0.49
                      ? { color: "rgba(234, 67, 52, 1)" }
                      : n.f1Score > 0.49 && n.f1Score <= 0.59
                      ? { color: "rgba(235, 115, 27, 1)" }
                      : n.f1Score > 0.59 && n.f1Score <= 0.69
                      ? { color: "rgba(66, 133, 244, 1)" }
                      : n.f1Score > 0.69 && n.f1Score <= 0.79
                      ? { color: "rgba(65, 168, 177, 1)" }
                      : { color: "rgba(51, 167, 83, 1)" }
                  }
                  value={(n.f1Score ?? 0).toFixed(2)}
                />
              ) : id < metricsLike.targets.length-1  ? (
                <input
                  key={`f-${id}`}
                  id="source"
                  type="text"
                  disabled="true"
                  placeholder="0"
                  className=""
                  style={
                    n.f1Score >= 0 && n.f1Score <= 0.49
                      ? { color: "rgba(234, 67, 52, 1)" }
                      : n.f1Score > 0.49 && n.f1Score <= 0.59
                      ? { color: "rgba(235, 115, 27, 1)" }
                      : n.f1Score > 0.59 && n.f1Score <= 0.69
                      ? { color: "rgba(66, 133, 244, 1)" }
                      : n.f1Score > 0.69 && n.f1Score <= 0.79
                      ? { color: "rgba(65, 168, 177, 1)" }
                      : { color: "rgba(51, 167, 83, 1)" }
                  }
                  value={(n.f1Score ?? 0).toFixed(2)}
                />
              ) : (
                <></>
              )
            )}
          </div>
        </div>

        <div className="line_2_accur">
          <div className="line_texta_acura line1_acura">{langv?.module_models?.accuracy?.text13}</div>
          <div className="line_texta_acura">
            <div className="accuracy_right_col0 ">
              <div className="accuracy_right_buttom_text">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="5" cy="5" r="5" fill="#33A753" />
                </svg>
                {langv?.module_models?.accuracy?.text4}
              </div>
            </div>

            <div className="accuracy_right_col0">
              <div className="accuracy_right_buttom_text">
                <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="5.75" cy="5" r="5" fill="#41A8B1" />
                </svg>
                {langv?.module_models?.accuracy?.text6}
              </div>
            </div>

            <div className="accuracy_right_col0 ">
              <div className="accuracy_right_buttom_text ">
                <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="5.5" cy="5" r="5" fill="#4285F4" />
                </svg>
                {langv?.module_models?.accuracy?.text8}
              </div>
            </div>

            <div className="accuracy_right_col0 ">
              <div className="accuracy_right_buttom_text ">
                <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="5.25" cy="5" r="5" fill="#EB731B" />
                </svg>
                {langv?.module_models?.accuracy?.text10}
              </div>
            </div>

            <div className="accuracy_right_col0 ">
              <div className="accuracy_right_buttom_text ">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="5" cy="5" r="5" fill="#EA4334" />
                </svg>
                {langv?.module_models?.accuracy?.text12}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Accuracy;
